<template>
	<div class="playbook-rule">
		<playbooks-svg-available v-if="userHasRule" />
		<playbooks-svg-unavailable v-else />
		<span>{{ ruleText }}<span v-if="!userHasRule" class="unavailable">(Not available in your plan)</span></span>
	</div>
</template>

<script>
import { rules } from '../../mixins/rules';
import { mapGetters } from 'vuex';

export default {
	mixins: [rules],
	props: {
		slug: {
			type: String,
			required: true,
		},
	},
	computed: {
		...mapGetters(['connected']),
		/**
		 * Determine if the user has access to this rule
		 *
		 * If the user isn't connected we want to show the same styles for when
		 * the user has a rule.
		 *
		 * @returns {boolean} true if the user has access, false otherwise.
		 */
		userHasRule() {
			return !this.connected || this.ruleAvailable(this.slug);
		},
		/**
		 * Generates the text to show for the rule.
		 *
		 * @returns {string}  The rule text, with the '*' at the end if needed
		 */
		ruleText() {
			let text = 'Rule Not Found';

			const rule = this.getRuleBySlug(this.slug);
			if (rule) {
				text = rule.friendlyText;
				if (!this.connected || !this.userHasRule) {
					// We want to add a '*' to the end of the rule name to match the designs
					// when a rule is not available in their current plan. We also want to
					// add this for when a user isn't connected.
					text += '*';
				}
			}

			return text;
		},
	},
};
</script>

<style lang="scss">
.unavailable {
	font-size: 12px;
	font-style: italic;
	font-weight: 400;
	line-height: 1.5em;
	margin-left: 5px;
}
</style>
